module.exports = __webpack_public_path__ + "media/customizations/fsr/logo-54889997649811347a60c5a9600b6a87.png";